export default {
  setDownloadURL(state, payload) {
    state.downloadURL = payload;
  },
  setCertificationDownloadURL(state, payload) {
    state.certificationDownloadURL = payload;
  },
};
